<template>
  <b-modal
    id="modal-toggle-active-container"
    :title="selectedItem.title"
    size="md"
    centered
    scrollable
    no-close-on-backdrop
    no-close-on-esc
    hide-header-close
  >
    <div>{{ selectedItem.desc }}</div>
    <template #modal-footer="{ cancel }">
      <div class="d-flex gap-2">
        <McButton
          variant="secondary"
          :disabled="isLoading && isLoadingLocal"
          :text="$t('global.action.cancel')"
          @click="() => handleCancel(cancel)"
        />
        <McButton
          :disabled="isLoading && isLoadingLocal"
          :text="selectedItem.title"
          @click="handleSubmit"
        />
      </div>
    </template>
  </b-modal>
</template>

<script>
import McButton from '@/components/McButton'

export default {
  components: {
    McButton,
  },
  props: {
    isToggleActive: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['submit', 'update:toggleKey'],
  data() {
    return {
      isLoadingLocal: false,
      items: [
        {
          key: 'enable',
          value: true,
          title: 'Aktifkan',
          desc: 'Apakah Anda yakin ingin mengaktifkan data berikut ?',
        },
        {
          key: 'disable',
          value: false,
          title: 'Nonaktifkan',
          desc: 'Apakah Anda yakin ingin menonaktifkan data berikut ?',
        },
      ],
    }
  },
  computed: {
    selectedItem() {
      return this.items.find((item) => item.value == this.isToggleActive)
    },
  },
  methods: {
    showModal() {
      this.$bvModal.show('modal-toggle-active-container')
    },
    hideModal() {
      this.$bvModal.hide('modal-toggle-active-container')
    },
    handleCancel(cancel) {
      this.$emit('update:toggleKey')
      cancel()
    },
    async handleSubmit() {
      this.isLoadingLocal = true
      await this.$emit('submit')
      
      this.isLoadingLocal = false
    },
  },
}
</script>
